module.exports = __webpack_public_path__ + "static/media/eclipse.64b7105f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/eclipse.png
// module id = 91
// module chunks = 0